// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Styles for VerifiedBadge component
 */

.verified-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 8px;
  border-radius: 12px;
  font-weight: 500;
  white-space: nowrap;
  transition: all 0.2s;
}

/* Size variants */
.verified-badge--small {
  font-size: 14px;
  padding: 3px 8px;
}

.verified-badge--medium {
  font-size: 14px;
  padding: 4px 8px;
}

.verified-badge--large {
  font-size: 14px;
  padding: 6px 12px;
}

/* Verified state */
.verified-badge--verified {
  background-color: #51A73B;
  color: #FFFFFF;
  border: none;
  border-radius: 6px;
}

.verified-badge--verified .verified-badge__icon {
  color: #FFFFFF;
}

/* Unverified state */
.verified-badge--unverified {
  background-color: #D19016;
  color: #FFFFFF;
  border: none;
  border-radius: 6px;
}

.verified-badge--unverified .verified-badge__icon {
  font-size: 0.9em;
  color: #FFFFFF;
}

/* Verifying state */
.verified-badge--verifying {
  background-color: #d1ecf1;
  color: #0c5460;
  border: 1px solid #bee5eb;
}

.verified-badge--verifying .verified-badge__icon {
  animation: rotate 2s linear infinite;
}

@keyframes rotate {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

/* Icon */
.verified-badge__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.verified-badge__icon ion-icon {
  font-size: 16px;
  --ionicon-stroke-width: 48px;
}

/* Text */
.verified-badge__text {
  display: inline-block;
}

/* Dark theme */
@media (prefers-color-scheme: dark) {
  .verified-badge--verified {
    background-color: #51A73B;
    color: #FFFFFF;
    border: none;
  }

  .verified-badge--verified .verified-badge__icon {
    color: #FFFFFF;
  }

  .verified-badge--unverified {
    background-color: #D19016;
    color: #FFFFFF;
    border: none;
  }

  .verified-badge--unverified .verified-badge__icon {
    color: #FFFFFF;
  }

  .verified-badge--verifying {
    background-color: #d1ecf1;
    color: #0c5460;
    border: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/devices/VerifiedBadge.css"],"names":[],"mappings":"AAAA;;EAEE;;AAEF;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA,kBAAkB;AAClB;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA,mBAAmB;AACnB;EACE,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA,qBAAqB;AACrB;EACE,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,OAAO,uBAAuB,EAAE;EAChC,KAAK,yBAAyB,EAAE;AAClC;;AAEA,SAAS;AACT;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,4BAA4B;AAC9B;;AAEA,SAAS;AACT;EACE,qBAAqB;AACvB;;AAEA,eAAe;AACf;EACE;IACE,yBAAyB;IACzB,cAAc;IACd,YAAY;EACd;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,yBAAyB;IACzB,cAAc;IACd,YAAY;EACd;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,yBAAyB;IACzB,cAAc;IACd,YAAY;EACd;AACF","sourcesContent":["/**\n * Styles for VerifiedBadge component\n */\n\n.verified-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 4px 8px;\n  border-radius: 12px;\n  font-weight: 500;\n  white-space: nowrap;\n  transition: all 0.2s;\n}\n\n/* Size variants */\n.verified-badge--small {\n  font-size: 14px;\n  padding: 3px 8px;\n}\n\n.verified-badge--medium {\n  font-size: 14px;\n  padding: 4px 8px;\n}\n\n.verified-badge--large {\n  font-size: 14px;\n  padding: 6px 12px;\n}\n\n/* Verified state */\n.verified-badge--verified {\n  background-color: #51A73B;\n  color: #FFFFFF;\n  border: none;\n  border-radius: 6px;\n}\n\n.verified-badge--verified .verified-badge__icon {\n  color: #FFFFFF;\n}\n\n/* Unverified state */\n.verified-badge--unverified {\n  background-color: #D19016;\n  color: #FFFFFF;\n  border: none;\n  border-radius: 6px;\n}\n\n.verified-badge--unverified .verified-badge__icon {\n  font-size: 0.9em;\n  color: #FFFFFF;\n}\n\n/* Verifying state */\n.verified-badge--verifying {\n  background-color: #d1ecf1;\n  color: #0c5460;\n  border: 1px solid #bee5eb;\n}\n\n.verified-badge--verifying .verified-badge__icon {\n  animation: rotate 2s linear infinite;\n}\n\n@keyframes rotate {\n  from { transform: rotate(0deg); }\n  to { transform: rotate(360deg); }\n}\n\n/* Icon */\n.verified-badge__icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.verified-badge__icon ion-icon {\n  font-size: 16px;\n  --ionicon-stroke-width: 48px;\n}\n\n/* Text */\n.verified-badge__text {\n  display: inline-block;\n}\n\n/* Dark theme */\n@media (prefers-color-scheme: dark) {\n  .verified-badge--verified {\n    background-color: #51A73B;\n    color: #FFFFFF;\n    border: none;\n  }\n\n  .verified-badge--verified .verified-badge__icon {\n    color: #FFFFFF;\n  }\n\n  .verified-badge--unverified {\n    background-color: #D19016;\n    color: #FFFFFF;\n    border: none;\n  }\n\n  .verified-badge--unverified .verified-badge__icon {\n    color: #FFFFFF;\n  }\n\n  .verified-badge--verifying {\n    background-color: #d1ecf1;\n    color: #0c5460;\n    border: none;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
